import { Outlet, ScrollRestoration, useLocation, useNavigate } from 'react-router'
import { ROUTES } from '@/shared/config'
import { useBackButtonFallback, useSettingsButton } from '@/shared/telegram'

/** Экраны без «Назад»: каталог — корень, онбординг — первый экран (в макете — «Закрыть» клиента). */
const ROOT_PATHS: ReadonlySet<string> = new Set([ROUTES.CATALOG, ROUTES.ONBOARDING])

/**
 * Оболочка всех экранов. Держит системную BackButton: на витрине и в
 * онбординге её нет, на остальных экранах — назад по истории. Если истории
 * нет (Mini App открыли сразу на подарке из чата), «назад» ведёт в витрину, а
 * не закрывает приложение.
 *
 * И пункт «Настройки» в меню ⋮ Telegram: с любого экрана — на «Оформление»
 * (31) поверх текущего, BackButton возвращает обратно. На самом «Оформлении»
 * пункта нет — второй экран поверх первого ни к чему. Профиль (20) — аватар в
 * шапке каталога (решение 02.11.2026).
 *
 * Экраны живут в колонке `max-w-app` по центру: на телефоне это вся ширина,
 * в широком окне — колонка, а фон (`body`) остаётся на всю ширину.
 */
export const AppLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isRoot = ROOT_PATHS.has(location.pathname)
  const isSettings = location.pathname === ROUTES.SETTINGS
  // `default` — первая запись истории: до неё в приложении ничего не было.
  const hasHistory = location.key !== 'default'

  useBackButtonFallback(
    isRoot ? null : () => (hasHistory ? navigate(-1) : navigate(ROUTES.CATALOG, { replace: true })),
  )
  useSettingsButton(isSettings ? null : () => navigate(ROUTES.SETTINGS))

  return (
    <div className="mx-auto flex w-full max-w-app flex-1 flex-col">
      <Outlet />
      <ScrollRestoration />
    </div>
  )
}
